import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

export const PhoneHeader = {
    components: {
        ItemEditBtns
    },
    props: {
        tagClass: String
    },
    methods: {
        clearPhone(phone){
            phone = phone.replace(/[^0-9+]/g,'');
            return 'tel:' + phone;
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData'])
    },
    template: `
            <ItemEditBtns  v-if="templateData && templateData.phone && templateData.phone.EDIT_BUTTON" :onclick="templateData.phone.EDIT_BUTTON">
                Редактировать телефон
            </ItemEditBtns>
            <a  v-if="templateData && templateData.phone && templateData.phone.CONTENT"
                :href="clearPhone(templateData.phone.CONTENT)"
                class="contacts-block__tel js-copyphone"
                >
                {{ templateData.phone.CONTENT }}
            </a>
    `
}